<template>
  <v-container fluid>
    <v-card class="pa-3 mt-4">
      <v-form ref="form" v-model="form.valid" @submit.prevent="store">
        <h1 class="pa-3">
          <inertia-link :href="route('warehouse.show', warehouse.id)">
            <b> Lager/{{ warehouse.name }} </b>
          </inertia-link>
        </h1>
        <v-row>
          <v-col cols="12" md="6" lg="4">
            <v-autocomplete
              v-model="form.selected"
              :items="purchaseItems"
              label="Produkt Auswählen"
              :rules="[(v) => !!v || 'Item is required']"
              outlined
            />
          </v-col>
          <v-col cols="12" md="6" lg="3">
            <MoneyInputField
              v-model="form.price"
              outlined
              label="Einkaufspreis/Netto"
            />
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <v-combobox
              v-model="form.serialCodes"
              label="Seriennummern Eingeben"
              :rules="[(v) => !!v || 'Item is required']"
              multiple
              outlined
              chips
              deletable-chips
            />
          </v-col>
        </v-row>
        <v-row class="justify-end ma-3">
          <v-btn
            :disabled="!form.valid"
            color="primary"
            type="submits"
          >
            Speichern
          </v-btn>
        </v-row>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import MoneyInputField from '@shared/MoneyInputField'
export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Wareneingang ' + this.warehouse.name,
      }
   },
   name: 'PurchaseItemStockCreate',
   components: {
      MoneyInputField
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      purchaseItems: {
         type: Object,
         required: true,
      },
      warehouse: {
         type: Object,
         required: true,
      },
   },
   data () {
      return {
         form: this.$inertia.form({
            selected: null,
            price: null,
            serialCodes: null,
            valid: false,
         }),
      }
   },
   methods: {
      store () {
         this.form.post(this.route('purchaseItemStock.store', this.warehouse.id), {
            // preserveScroll: true,
            onSuccess: () => this.form.reset(),
         })
      },
   },
}
</script>

<style></style>
